module.exports = "/packs/writing_exam_medal-5e3c99eeeb4cd1b0841efa27348b019e.png";